import { t } from "i18next";
import React from "react";
import BannerImages from "../../Common/BannerImages";

function PopupGeneral() {
    const popupImagePathDesktop = React.useMemo(
        () => ["SiteWeb", "Divers", "ImagePopup", "Desktop"],
        []
    );
    const popupImagePathMobile = React.useMemo(
        () => ["SiteWeb", "Divers", "ImagePopup", "Mobile"],
        []
    );
    return (
        <div className="mt-3 mx-2">
            <h5 style={{ fontWeight: "bold" }}>{t("General pop-up")}</h5>
            <div
                className="banner-images"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                {" "}
                <div style={{ width: "40%" }}>
                    <BannerImages
                        dataPath={popupImagePathDesktop}
                        title="Desktop"
                        size="706*621 (png,jpg,jpeg ou webp)"
                    />
                </div>
                <div style={{ width: "40%" }}>
                    {" "}
                    <BannerImages
                        dataPath={popupImagePathMobile}
                        title="Mobile"
                        size="706*621 (png,jpg,jpeg ou webp)"
                    />
                </div>
            </div>
        </div>
    );
}

export default PopupGeneral;
